import React from 'react';
import Box from '@components/Atoms/Box';
import Chip from '@components/Atoms/Chip';
import { Option } from './CustomDropdown';

const CustomOptionWithCount = ({ value, label, count }: Option) => {
  // Determine chip styling based on state
  let chipColor: 'default' | 'primary' = 'default';
  chipColor = 'primary';

  const chipVariant: 'outlined' | 'filled' = 'filled';

  let chipBackgroundColor = 'grey.200';
  let chipTextColor = 'text.secondary';

  chipBackgroundColor = 'primary.main';
  chipTextColor = 'primary.contrastText';

  return (
    <Box
      sx={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',
        width: '100%',
        gap: 1,
        opacity: 1,
      }}
    >
      <Box
        component="span"
        sx={{
          flex: 1,
          fontSize: '0.875rem',
          lineHeight: 1.3,
          wordWrap: 'break-word',
          overflow: 'hidden',
          paddingRight: 1, // Space between text and count
          // Handle up to 2 lines of text
          display: '-webkit-box',
          WebkitLineClamp: 2,
          WebkitBoxOrient: 'vertical',
          textOverflow: 'ellipsis',
          color: 'inherit',
        }}
      >
        {value ? `${value} - ${label}` : `${label}`}
      </Box>
      {count !== undefined && (
        <Chip
          label={count}
          size="small"
          color={chipColor}
          clickable={false}
          variant={chipVariant}
          sx={{
            flexShrink: 0,
            alignSelf: 'flex-start',
            marginTop: '2px', // Slight offset to align with first line of text
            backgroundColor: chipBackgroundColor,
            color: chipTextColor,
            height: '20px',
            minWidth: '28px', // Ensure minimum width for larger numbers
            '& .MuiChip-label': {
              fontSize: '0.75rem',
              fontWeight: 'bold',
              padding: '0 6px',
            },
          }}
        />
      )}
    </Box>
  );
};

export default CustomOptionWithCount;
